'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0a0a0a]/95 backdrop-blur-md border-b border-[#1a1a1a]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2 cursor-pointer">
          <Image
            src="/assets/images/file_000000003b4c7246b53d1d2443541966_2-1779985415242.png"
            alt="MDeliva logo"
            width={120}
            height={40}
            className="h-10 w-auto object-contain"
          />
          <span className="text-white font-bold text-xl tracking-tight">MDeliva</span>
        </Link>

        {/* Nav Links */}
        <div className="hidden md:flex items-center gap-8">
          <a href="#features" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm font-medium">
            Features
          </a>
          <a href="#vendors" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm font-medium">
            Vendors
          </a>
          <Link href="/about" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm font-medium">
            About
          </Link>
          <Link href="/faq" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm font-medium">
            FAQ
          </Link>
          <Link href="/contact" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm font-medium">
            Contact
          </Link>
          <button className="bg-[#f97316] text-white font-semibold px-5 py-2 rounded-full text-sm hover:bg-[#ea6c00] transition-all duration-200 hover:scale-105">
            Get Started
          </button>
        </div>

        {/* Mobile menu button */}
        <button
          className="md:hidden text-white p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle mobile menu"
        >
          {mobileOpen ? (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-[#0a0a0a]/98 backdrop-blur-md border-t border-[#1a1a1a] px-6 py-4 flex flex-col gap-4">
          <a href="#features" onClick={() => setMobileOpen(false)} className="text-gray-300 hover:text-white transition-colors duration-200 text-sm font-medium py-2">
            Features
          </a>
          <a href="#vendors" onClick={() => setMobileOpen(false)} className="text-gray-300 hover:text-white transition-colors duration-200 text-sm font-medium py-2">
            Vendors
          </a>
          <Link href="/about" onClick={() => setMobileOpen(false)} className="text-gray-300 hover:text-white transition-colors duration-200 text-sm font-medium py-2">
            About
          </Link>
          <Link href="/faq" onClick={() => setMobileOpen(false)} className="text-gray-300 hover:text-white transition-colors duration-200 text-sm font-medium py-2">
            FAQ
          </Link>
          <Link href="/contact" onClick={() => setMobileOpen(false)} className="text-gray-300 hover:text-white transition-colors duration-200 text-sm font-medium py-2">
            Contact
          </Link>
          <button className="bg-[#f97316] text-white font-semibold px-5 py-2.5 rounded-full text-sm hover:bg-[#ea6c00] transition-all duration-200 w-full mt-2">
            Get Started
          </button>
        </div>
      )}
    </nav>
  );
}
